module.exports = "<a embed-only=true href=https://www.ushahidi.com class=ushahidi-bug target=_blank> <ng-include include-replace src=\"'common/directives/mode-bar/ushahidi-logo.html'\"></ng-include> <span class=hidden>Powered by Ushahidi</span> </a> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/directives/ush-logo.html
// module id = 517
// module chunks = 0